import { z } from 'zod'

import { passwordValidateSchema } from './passwordValidateSchema'

/**
 * 重置密码
 */
export const passwordConfirmSchema = z
  .object({
    password: passwordValidateSchema.pick({ password: true }).shape.password,
    confirmPassword: passwordValidateSchema.pick({ password: true }).shape.password,
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Entered passwords differ!',
    path: ['confirmPassword'], // 将错误关联到 confirmPassword 字段
  })
